var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Metrika } from '../classes';
var defaultOptions = {
    screen: {
        fullscreen: false,
    },
};
var YandexGames = /** @class */ (function () {
    function YandexGames() {
    }
    Object.defineProperty(YandexGames, "signed", {
        set: function (signed) {
            YandexGames._signed = signed;
            YandexGames._payments = null;
        },
        enumerable: false,
        configurable: true
    });
    YandexGames.init = function (options, callback, count) {
        var _this = this;
        if (count === void 0) { count = 1; }
        if (!YandexGames.script) {
            var src_1 = DEVELOPMENT ? 'fake-yandex-sdk.js' : '/sdk/';
            var script = (YandexGames.script = Array.from(document.scripts).find(function (s) { return s.src.includes(src_1); }));
            if (!script) {
                console.warn("Script \"".concat(src_1, "\" not found."));
            }
            if (window['YaGames']) {
                YandexGames.initSdk(options, callback);
            }
            else {
                if (script) {
                    script.onload = function () {
                        YandexGames.initSdk(options, callback);
                    };
                    script.onerror = function () {
                        var sdk = null;
                        YandexGames.sdk = sdk;
                        _this.callbacks.forEach(function (cb) { return cb(sdk); });
                        _this.callbacks = [];
                        if (callback)
                            callback();
                    };
                    setTimeout(function () {
                        if (!YandexGames.sdk) {
                            // TODO нужно проверить как часто это бывает.
                            Metrika.logError({ message: 'No SDK after 5s.' });
                        }
                    }, 5000);
                }
                else if (count < 25) {
                    setTimeout(function () {
                        console.warn({ count: count });
                        YandexGames.init(options, callback, count + 1);
                    }, 1);
                }
            }
        }
    };
    YandexGames.initSdk = function (options, callback) {
        var _this = this;
        if (YandexGames.YaGames) {
            return;
        }
        YandexGames.YaGames = window['YaGames'];
        YandexGames.YaGames.init(options || defaultOptions).then(function (sdk) {
            YandexGames.sdk = sdk;
            _this.callbacks.forEach(function (cb) { return cb(sdk); });
            _this.callbacks = [];
            if (callback)
                callback();
            YandexGames.unregisterServiceWorker();
        });
    };
    YandexGames.unregisterServiceWorker = function () {
        if (FOR_YANDEX && navigator && navigator.serviceWorker) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                for (var _i = 0, registrations_1 = registrations; _i < registrations_1.length; _i++) {
                    var registration = registrations_1[_i];
                    registration.unregister();
                    console.log('serviceWorker unregister');
                }
            });
        }
    };
    YandexGames.ready = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdk, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, YandexGames.getSdkPromise()];
                    case 1:
                        sdk = _a.sent();
                        if (sdk.features && sdk.features.LoadingAPI) {
                            sdk.features.LoadingAPI.ready();
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        Metrika.logError(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    YandexGames.getLang = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                var sdk, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (DEVELOPMENT && location.search.includes('english'))
                                return [2 /*return*/, resolve('en')];
                            if (DEVELOPMENT && location.search.includes('turkish'))
                                return [2 /*return*/, resolve('tr')];
                            if (DEVELOPMENT && location.search.includes('spanish'))
                                return [2 /*return*/, resolve('es')];
                            if (DEVELOPMENT && location.search.includes('deutsch'))
                                return [2 /*return*/, resolve('de')];
                            if (DEVELOPMENT && location.search.includes('hindi'))
                                return [2 /*return*/, resolve('hi')];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, YandexGames.getSdkPromise()
                                // https://yandex.ru/dev/games/doc/dg/sdk/sdk-environment.html
                            ];
                        case 2:
                            sdk = _a.sent();
                            // https://yandex.ru/dev/games/doc/dg/sdk/sdk-environment.html
                            if (sdk.environment && sdk.environment.i18n && sdk.environment.i18n.lang) {
                                resolve(sdk.environment.i18n.lang);
                            }
                            else {
                                reject();
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            reject();
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); }, 1);
        });
    };
    // Реклама (Fullscreen + Rewarded)
    YandexGames.showFullscreenAdv = function (onClose) {
        return __awaiter(this, void 0, void 0, function () {
            var sdk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getSdkPromise()];
                    case 1:
                        sdk = _a.sent();
                        if (DEVELOPMENT && location.search.includes('no-native-ad')) {
                            setTimeout(function () { return onClose && onClose(false); }, 100);
                            return [2 /*return*/];
                        }
                        sdk.adv.showFullscreenAdv({
                            callbacks: {
                                onClose: function (wasShown) {
                                    if (onClose) {
                                        onClose(wasShown);
                                    }
                                },
                                onError: function (error) {
                                    Metrika.logError(error);
                                },
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    YandexGames.showRewardedVideo = function (callbacks) {
        YandexGames.getSdkPromise().then(function (sdk) {
            sdk.adv.showRewardedVideo({ callbacks: callbacks });
        });
    };
    // Реклама (Sticky баннеры)
    YandexGames.getBannerAdvStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getSdkPromise()];
                    case 1:
                        sdk = _a.sent();
                        return [2 /*return*/, sdk.adv.getBannerAdvStatus()];
                }
            });
        });
    };
    YandexGames.showBannerAdv = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getSdkPromise()];
                    case 1:
                        sdk = _a.sent();
                        return [2 /*return*/, sdk.adv.showBannerAdv()];
                }
            });
        });
    };
    YandexGames.hideBannerAdv = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getSdkPromise()];
                    case 1:
                        sdk = _a.sent();
                        return [2 /*return*/, sdk.adv.hideBannerAdv()];
                }
            });
        });
    };
    // Авторизация
    YandexGames.getPlayer = function (options, force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var sdk, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!YandexGames.player || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, YandexGames.getSdkPromise()];
                    case 1:
                        sdk = _b.sent();
                        _a = YandexGames;
                        return [4 /*yield*/, sdk.getPlayer(options || YandexGames.getPlayerOptions)];
                    case 2:
                        _a.player = _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/, YandexGames.player];
                }
            });
        });
    };
    YandexGames.getPlayerId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var player;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getPlayer({ scopes: false })];
                    case 1:
                        player = _a.sent();
                        return [2 /*return*/, player.getUniqueID()];
                }
            });
        });
    };
    YandexGames.openAuthDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getSdkPromise()];
                    case 1:
                        sdk = _a.sent();
                        return [4 /*yield*/, sdk.auth.openAuthDialog()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // Данные игрока
    YandexGames.setData = function (data, flush) {
        if (flush === void 0) { flush = false; }
        return __awaiter(this, void 0, void 0, function () {
            var player;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getPlayer()];
                    case 1:
                        player = _a.sent();
                        return [2 /*return*/, player.setData(data, flush)];
                }
            });
        });
    };
    YandexGames.getData = function (keys) {
        return __awaiter(this, void 0, void 0, function () {
            var player;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getPlayer({ scopes: false })];
                    case 1:
                        player = _a.sent();
                        return [2 /*return*/, player.getData(keys)];
                }
            });
        });
    };
    YandexGames.setStats = function (stats) {
        return __awaiter(this, void 0, void 0, function () {
            var player;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getPlayer()];
                    case 1:
                        player = _a.sent();
                        return [2 /*return*/, player.setStats(stats)];
                }
            });
        });
    };
    YandexGames.incrementStats = function (increments) {
        return __awaiter(this, void 0, void 0, function () {
            var player;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getPlayer()];
                    case 1:
                        player = _a.sent();
                        return [2 /*return*/, player.incrementStats(increments)];
                }
            });
        });
    };
    YandexGames.getStats = function (keys) {
        return __awaiter(this, void 0, void 0, function () {
            var player;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, YandexGames.getPlayer()];
                    case 1:
                        player = _a.sent();
                        return [2 /*return*/, player.getStats(keys)];
                }
            });
        });
    };
    // Внутриигровые покупки
    YandexGames.getPayments = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!YandexGames._payments) {
                    // const sdk = await YandexGames.getSdkPromise()
                    // YandexGames.payments = sdk.getPayments({signed: false}) // TODO нужна возможность настройки
                    YandexGames._payments = new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                        var sdk, payments;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, YandexGames.getSdkPromise()];
                                case 1:
                                    sdk = _a.sent();
                                    return [4 /*yield*/, sdk.getPayments({ signed: YandexGames._signed })];
                                case 2:
                                    payments = _a.sent();
                                    resolve(payments);
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                return [2 /*return*/, YandexGames._payments];
            });
        });
    };
    YandexGames.purchase = function (id, developerPayload) {
        return __awaiter(this, void 0, void 0, function () {
            var payments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPayments()];
                    case 1:
                        payments = _a.sent();
                        console.log('payments.purchase', { id: id, developerPayload: developerPayload });
                        // return payments.purchase({id: id})
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                payments
                                    .purchase({ id: id })
                                    .then(function (purchase) { return resolve(purchase); })
                                    .catch(function (err) { return reject(err); });
                            })];
                }
            });
        });
    };
    YandexGames.consumePurchase = function (purchaseToken) {
        return __awaiter(this, void 0, void 0, function () {
            var payments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPayments()];
                    case 1:
                        payments = _a.sent();
                        return [2 /*return*/, payments.consumePurchase(purchaseToken)];
                }
            });
        });
    };
    YandexGames.getPurchases = function () {
        return __awaiter(this, void 0, void 0, function () {
            var payments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPayments()];
                    case 1:
                        payments = _a.sent();
                        return [2 /*return*/, payments.getPurchases()];
                }
            });
        });
    };
    YandexGames.getCatalog = function () {
        return __awaiter(this, void 0, void 0, function () {
            var payments;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPayments()];
                    case 1:
                        payments = _a.sent();
                        return [2 /*return*/, payments.getCatalog()];
                }
            });
        });
    };
    // Соревновательные таблицы
    YandexGames.getLeaderboards = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sdk, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!YandexGames.lb) return [3 /*break*/, 3];
                        return [4 /*yield*/, YandexGames.getSdkPromise()];
                    case 1:
                        sdk = _b.sent();
                        _a = YandexGames;
                        return [4 /*yield*/, sdk.getLeaderboards()];
                    case 2:
                        _a.lb = _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/, YandexGames.lb];
                }
            });
        });
    };
    YandexGames.setLeaderboardScore = function (leaderboardName, score, extraData) {
        return __awaiter(this, void 0, void 0, function () {
            var lb;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLeaderboards()];
                    case 1:
                        lb = _a.sent();
                        return [4 /*yield*/, lb.setLeaderboardScore(leaderboardName, score, extraData)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    YandexGames.safeSetLeaderboardScore = function (leaderboardName, score, extraData, force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var entry, err_2, err_3;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 12]);
                        return [4 /*yield*/, YandexGames.getLeaderboardPlayerEntry(leaderboardName)];
                    case 1:
                        entry = _c.sent();
                        if (!(score > entry.score || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, YandexGames.setLeaderboardScore(leaderboardName, score, extraData)];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        Metrika.params({ error: { 'score < entry.score': 1 } });
                        _c.label = 4;
                    case 4: return [3 /*break*/, 12];
                    case 5:
                        err_2 = _c.sent();
                        if (!(err_2.code === 'LEADERBOARD_PLAYER_NOT_PRESENT')) return [3 /*break*/, 10];
                        _c.label = 6;
                    case 6:
                        _c.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, YandexGames.setLeaderboardScore(leaderboardName, score, extraData)];
                    case 7:
                        _c.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        err_3 = _c.sent();
                        console.error(err_3);
                        Metrika.params({ error: (_a = {}, _a[err_3.message] = 1, _a) });
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        console.error(err_2);
                        Metrika.params({ error: (_b = {}, _b[err_2.message] = 1, _b) });
                        _c.label = 11;
                    case 11: return [3 /*break*/, 12];
                    case 12: return [2 /*return*/];
                }
            });
        });
    };
    YandexGames.getLeaderboardPlayerEntry = function (leaderboardName) {
        return __awaiter(this, void 0, void 0, function () {
            var lb;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLeaderboards()];
                    case 1:
                        lb = _a.sent();
                        return [2 /*return*/, lb.getLeaderboardPlayerEntry(leaderboardName)];
                }
            });
        });
    };
    YandexGames.getLeaderboardEntries = function (leaderboardName, options) {
        return __awaiter(this, void 0, void 0, function () {
            var lb;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLeaderboards()];
                    case 1:
                        lb = _a.sent();
                        return [2 /*return*/, lb.getLeaderboardEntries(leaderboardName, options)];
                }
            });
        });
    };
    // Приватные методы
    YandexGames.getSdk = function (callback) {
        if (YandexGames.sdk !== undefined) {
            callback(YandexGames.sdk);
        }
        else {
            YandexGames.callbacks.push(callback);
        }
    };
    YandexGames.getSdkPromise = function () {
        return new Promise(function (resolve, reject) {
            YandexGames.getSdk(function (sdk) { return (sdk ? resolve(sdk) : reject(null)); });
        });
    };
    YandexGames.getPlayerOptions = { scopes: false };
    YandexGames._signed = false;
    YandexGames.sdk = undefined;
    YandexGames.callbacks = [];
    return YandexGames;
}());
export { YandexGames };
